export const DEFAULT_CHECKOUT_RETURN_PATH = "/dashboard";
export const CHECKOUT_RETURN_PATH_KEY = "license.returnPath";

export const isSafeReturnPath = (value) => (
    typeof value === "string"
    && value.startsWith("/")
    && !value.startsWith("//")
);

export const checkoutReturnPath = (location = {}) => {
    const candidate = `${location.pathname || DEFAULT_CHECKOUT_RETURN_PATH}${location.search || ""}${location.hash || ""}`;
    return isSafeReturnPath(candidate)
        ? candidate
        : DEFAULT_CHECKOUT_RETURN_PATH;
};

export const rememberCheckoutReturnPath = (location, storage = sessionStorage) => {
    const value = checkoutReturnPath(location);
    storage.setItem(CHECKOUT_RETURN_PATH_KEY, value);
    return value;
};

export const consumeCheckoutReturnPath = (storage = sessionStorage) => {
    const value = storage.getItem(CHECKOUT_RETURN_PATH_KEY);
    storage.removeItem(CHECKOUT_RETURN_PATH_KEY);
    return isSafeReturnPath(value)
        ? value
        : DEFAULT_CHECKOUT_RETURN_PATH;
};

export const checkoutQuery = (search = "") => {
    const params = new URLSearchParams(search);
    return {
        action: params.get("action") || "",
        category: params.get("category") || "",
        plan: params.get("plan") || "",
        result: params.get("checkout") || "",
        sessionId: params.get("session_id") || "",
    };
};
